import React, { useState } from "react"
import clsx from "clsx"

import { Link } from "components"

function CategoryLink({ label, href }) {
  const [isHovering, setIsHovering] = useState(false)

  return (
    <Link
      href={href}
      className={clsx(
        "focus:text-violet transition-colors duration-150 ease-out",
        isHovering === true && "text-violet"
      )}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {label}
    </Link>
  )
}

function Hero({ categories, currentCategory }) {
  return (
    <header className="pt-8 pb-8 md:pb-24 md:pt-24 wrapper default-grid gap-y-8 md:gap-y-12">
      <div className="flex justify-center col-span-full">
        <div className="w-24 md:w-32 lg:w-44">
          <div className="aspect-w-12 aspect-h-7">
            <svg
              className="text-darkNavy"
              width="100%"
              height="100%"
              viewBox="0 0 178 104"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Small growing plant</title>
              <path
                d="M35.17 98.433c.187-.02.37-.07.544-.143l6.386 4.788 1.158-1.545-5.496-4.12 11.103-4.759h13.117c.293 0 .571-.089.832-.216l4.21 2.806 1.814 3.631a.97.97 0 00.865.535h7.721v-1.93h-7.125l-1.664-3.328a.965.965 0 00-.328-.37l-3.85-2.568 7.854-6.281h33.392l8.196 6.557-5.99 5.99h-3.461v1.93h3.861a.972.972 0 00.683-.282l6.555-6.555c.159.04.317.081.483.081h13.056l9.196 4.598-3.382 2.26-3.86 1.931.863 1.727 3.965-1.99 4.401-2.934c.204.1.424.166.652.191l36.676 3.861.403-3.84-36.326-3.823L130.405 89a1.892 1.892 0 00-.863-.207h-12.835l-9.122-7.298a1.934 1.934 0 00-1.207-.423H91.901V65.605c34.68-.52 62.735-28.874 62.735-63.675 0-1.065-.865-1.93-1.931-1.93-31.38 0-57.517 22.816-62.734 52.728C84.753 22.816 58.617 0 27.236 0c-1.065 0-1.93.865-1.93 1.93 0 34.801 28.055 63.156 62.735 63.675v15.467H71.633c-.438 0-.863.149-1.206.423l-9.123 7.298H48.47c-.26 0-.521.053-.76.157l-13.25 5.677L0 98.457l.427 3.835 34.743-3.859zm115.572-94.54c-1.017 31.44-26.406 56.826-57.845 57.846 1.02-31.441 26.407-56.828 57.845-57.846zm-121.542 0C60.638 4.911 86.025 30.3 87.044 61.74c-31.441-1.02-56.828-26.407-57.846-57.846z"
                fill="currentColor"
              />
              <path
                d="M39.48 12.818l-1.333 1.395L82.54 56.678l1.334-1.395-44.394-42.465zM146.229 7.041L97.973 55.297l1.365 1.365 48.256-48.256-1.365-1.365zM34.96 83.003H31.1v3.86h3.86v-3.86zM11.794 79.142h-3.86v3.86h3.86v-3.86zM58.122 73.355h-3.86v3.86h3.86v-3.86zM121.822 73.355h-3.861v3.86h3.861v-3.86zM150.777 77.21h-3.861v3.861h3.861v-3.86zM166.218 84.933h-3.861v3.86h3.861v-3.86z"
                fill="currentColor"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className="space-y-4 md:space-y-8 col-span-full">
        <div className="relative -mx-6 italic text-center text-darkPurple h1 sm:mx-0">
          <div
            className="absolute w-screen h-3 transform -translate-x-1/2 bg-gold left-1/2"
            style={{ top: "0.167em", height: "0.1333em" }}
          />
          <div
            className="absolute w-screen h-3 transform -translate-x-1/2 bg-gold left-1/2"
            style={{ bottom: "0.117em", height: "0.1333em" }}
          />
          <h1
            className="relative inline-block transform -skew-x-12 bg-white"
            style={{ padding: "0 .75em" }}
          >
            <span className="block transform skew-x-12">Talking Shop</span>
          </h1>
        </div>
        <p className="text-center text-mineralGray bold-subtitle">
          Continuous improvement at Hearthside
        </p>
      </div>
      <nav className="hidden col-span-full md:block">
        <ul className="flex justify-center pt-14 space-x-14">
          {categories?.nodes?.map((category, i) => {
            if (currentCategory.slug !== category.slug)
              return (
                <li className="text-mineralGray h4" key={`category--${i}`}>
                  <CategoryLink
                    label={category.name}
                    href={`/news/${category.slug === "/" ? "" : category.slug}`}
                  />
                </li>
              )
            if (currentCategory.slug === category.slug)
              return (
                <li
                  className="text-violet h4"
                  style={{
                    textDecoration: "underline",
                    textDecorationThickness: 3,
                    textUnderlineOffset: 3,
                  }}
                  key={`category--${i}`}
                >
                  {category.name}
                </li>
              )
            else return null
          })}
        </ul>
      </nav>
    </header>
  )
}

export default Hero
